var _effectorFileName = "/builds/gmini/front-ui-kit/src/ExplorerLayout/BottomLogo.tsx";
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BottomLogo = /*#__PURE__*/React.memo(() => /*#__PURE__*/_jsxs("svg", {
  width: "35",
  height: "34",
  viewBox: "0 0 35 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    d: "M5.44336 4.79669V28.995H20.5672V22.9455H11.4928V10.8462H29.6413V4.79669H5.44336Z",
    fill: "#04083D"
  }), /*#__PURE__*/_jsx("path", {
    d: "M14.5195 19.963H23.5936V28.9945H29.643V13.9136H14.5195V19.963Z",
    fill: "#04083D"
  }), /*#__PURE__*/_jsx("path", {
    d: "M32.6598 1.99978V32.2226H2.43728V1.99978H32.6598ZM34.1908 0.46875H0.90625V33.7533H34.1908V0.46875Z",
    fill: "#04083D"
  })]
}));
BottomLogo.displayName = 'BottomLogo';